import Repository from './Repository';


const resource = '/dashboard';

export default {
    getDashboardData() {
        return Repository.get(`${resource}/GetDashboardData`, {withCredentials: true});
    },
};
